

































































import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogDetail2 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogDetail2.vue';

@Component({
  components: { DialogDetail2 },
})
export default class DialogList2 extends Vue {
  private dialogVisible = false;
  private title = '';

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total: any = 0;
  private tableData: any = [];

  private filterForm: any = {
    areaId: '',
    finishFlag: null,
  };

  private showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.title = data.type ? '已整改' : '未整改';
    this.filterForm.finishFlag = data.type;
    this.filterForm.areaId = data.areaId ? data.areaId : '';
    this.getData();
    this.dialogVisible = true;
  }
  private getData() {
    zyScreenServer
      .getHazardManageList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        paging: true,
        areaId: this.filterForm.areaId, // 区域id
        finishFlag: this.filterForm.finishFlag,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  private filterItemClick(data: any) {
    if (data.value === '0') {
      // this.tableData = [];
      return;
    }
    this.filterForm.areaId = data.other;
    this.getData();
  }
  showDetail(item: any) {
    const refName = 'DialogDetail2Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }

  handleClose(done: any) {
    done();
  }
}
